import { render, staticRenderFns } from "./PlacementsStartComponentDevelopmentAdmin.vue?vue&type=template&id=0f7ca4bc&scoped=true&"
import script from "./PlacementsStartComponentDevelopmentAdmin.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentDevelopmentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsStartComponentDevelopmentAdmin.vue?vue&type=style&index=0&id=0f7ca4bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ca4bc",
  null
  
)

export default component.exports